﻿import { api } from "./api.js";

/** GET /api/inventory */
export const list = () => api.get("/inventory");

/** GET /api/inventory/low-stock */
export const getLowStock = () => api.get("/inventory/low-stock");

export const getById = (id) => api.get(`/inventory/${id}`);

export const create = (payload) => api.post("/inventory", payload);

export const update = (id, payload) => api.put(`/inventory/${id}`, payload);

/** PATCH /api/inventory/:id/stock — body carries the quantity delta/absolute value. */
export const updateStock = (id, payload) =>
  api.patch(`/inventory/${id}/stock`, payload);

export const remove = (id) => api.delete(`/inventory/${id}`);

export default { list, getLowStock, getById, create, update, updateStock, remove };
